import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";

const ModalTarea = ({ estado, onCloseModal, onReturnValue, dataEdit }) => {
  const [tarea, settarea] = useState("");
  const [fecha, setfecha] = useState("");
  const [hora, sethora] = useState("");
  useEffect(() => {
    if (dataEdit) {
      settarea(dataEdit.tarea || "");
      setfecha(dataEdit.fecha || "");
      sethora(dataEdit.hora || "");
    } else {
      settarea("");
      sethora("")
      setfecha("")
    }
  }, [dataEdit]);

  const handleGuardar = () => {
    const tareaOb = {
      idtarea: dataEdit?.idtarea || null,
      tarea,
      fecha,
      hora
    };
    onReturnValue(tareaOb);
  };

  return (
    <Modal show={estado} onHide={onCloseModal}>
      <Modal.Header closeButton>
        <Modal.Title>{dataEdit ? "Editar Tarea" : "Nueva Tarea"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group>
            <Form.Label>Tarea</Form.Label>
            <Form.Control
              type="text"
              value={tarea}
              onChange={(e) => settarea(e.target.value)}
              placeholder="Ingrese la tarea"
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Fecha</Form.Label>
            <Form.Control
              type="date"
              value={fecha}
              onChange={(e) => setfecha(e.target.value)}
              placeholder="Ingrese la fecha"
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Hora</Form.Label>
            <Form.Control
              type="time"
              value={hora}
              onChange={(e) => sethora(e.target.value)}
              placeholder="Ingrese la hora"
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={onCloseModal}>
          Cancelar
        </Button>
        <Button variant="primary" onClick={handleGuardar}>
          Guardar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalTarea;